// These are the possible statusses of Invoice.AccStatusText
enum InvoiceStatusEnum {
  BEFORE_DUE = 'before due',
  DUE_DATE = 'due date',
  OVERDUE = 'overdue',
  CLEARED = 'cleared',
  REVERSED = 'reversed',
}
export default InvoiceStatusEnum;
